// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Error } from './Typography.jsx';
import styles from '../styles/PatientCard.scss';

type Props = {
  name: string,
  house: string,
  sex: string,
  age: string,
  extra1?: string,
  extra2?: string,
  overdue?: boolean,
  link: string,
}

class PatientCard extends Component<Props> {
  render() {
    return (
      <Link to={this.props.link} className={styles.patientCard}>
        <div>
          <div className={styles.name}>{this.props.name}</div>
          <div>{this.props.house}</div>
          <div>{this.props.sex}, {this.props.age}</div>
        </div>
        <div className={styles.rightAlign}>
          <div>{this.props.extra1}</div>
          <div>
            {
              this.props.overdue && this.props.extra2
                ? <Error>{`${this.props.extra2}`}</Error>
                : this.props.extra2
            }
          </div>
          <div>
            {this.props.overdue && <Error>(overdue)</Error>}
          </div>
        </div>
      </Link>
    );
  }
}

export default PatientCard;



// WEBPACK FOOTER //
// ./client/src/components/PatientCard.jsx